import { GlobalAppData } from '@/types';

export class AppStore {
    private globalData: Window['siteData']['global'];
    private pageData: Record<string, unknown> = {};

    constructor() {
        this.setGlobalData();
        this.setPageData();
    }

    setGlobalData() {
        const globalData = window.siteData?.global;

        if (!globalData) {
            throw new Error(`Couldn't read global siteData.`);
        }

        this.globalData = window.siteData?.global as GlobalAppData;
    }

    setPageData() {
        const pageData = window.siteData?.page;

        if (!pageData) {
            throw new Error(`Couldn't read page siteData.`);
        }

        this.pageData = window.siteData?.page;
    }

    getGlobalData() {
        return this.globalData;
    }

    getPageData<T = unknown>(): T {
        return this.pageData as T;
    }
}
